import { render, staticRenderFns } from "./Dog-form.vue?vue&type=template&id=a3592464&scoped=true&"
import script from "./Dog-form.vue?vue&type=script&lang=js&"
export * from "./Dog-form.vue?vue&type=script&lang=js&"
import style0 from "./Dog-form.vue?vue&type=style&index=0&id=a3592464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3592464",
  null
  
)

export default component.exports